export const personnelEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/settings/key-figures/personnel` as const
}

export default personnelEndpoints
